import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
	selector: 'app-back-btn',
	templateUrl: './back-btn.component.html',
	styleUrls: ['./back-btn.component.scss'],
})
export class BackButtonComponent {
	path: any;

	constructor(private router: Router, private route: ActivatedRoute, private location: Location) {
		this.path = this.route.parent?.routeConfig?.path;
	}

	goBack() {
		this.router.navigate([".."], { relativeTo: this.route });
		// let cur_path = this.location.path();
		// // this.location.back();
		// if (cur_path === this.location.path()) {
		// 	this.router.navigate([this.path || 'sale']);
		// }
	}
}
